import { encoded } from './ltv-data';

const matrix: Record<string, number> = JSON.parse(atob(encoded));
const PLAN: Record<string, string> = { 'Smash Pro': 'P', 'Smash Team': 'T' };
const DURATION: Record<string, string> = { '1months': '1m', '1years': '1y', '2years': '2y' };

export function getLtv(planName: string, countryCode: string, currency: string, duration: string): number | null {
    const key = `${PLAN[planName] ?? planName}|${countryCode}|${currency}|${DURATION[duration] ?? duration}`;
    return matrix[key] ?? null;
}
